import type { CSSProperties, FC } from 'react';

type SearchAdServerIntegrationSkyscraperLayoutProps = {
  mountPointId: string;
};

interface CssWithCustomProperties extends CSSProperties {
  '--top-spacing': string;
}

export const SearchAdServerIntegrationSkyscraperLayout: FC<
  SearchAdServerIntegrationSkyscraperLayoutProps
> = ({ mountPointId }) => {
  const style: CssWithCustomProperties = {
    '--top-spacing': '44px', // for vertical alignment with the top of the FilterSettings component
  };

  return (
    <div
      style={style}
      className="absolute top-0 right-[calc(-160px-0.5rem)] hidden h-full pt-(--top-spacing) pl-2 lg:block" // Skyscraper ads are desktop-only. Viewport visibility is handled via CSS rather than JS to avoid useMediaType dependency.
    >
      <div
        role="marquee"
        className="sticky top-(--top-spacing) min-h-[600px] w-[160px]" // add `border border-[red]` for local testing, because GTM is not available locally
      >
        <div id={mountPointId} />
      </div>
    </div>
  );
};
